export default "__VITE_ASSET__DTG_qqrG__"